export default __webpack_public_path__ + "37c5e076fe4b9266d418351ba83a4a1b.png";